import { Typography } from "@mui/material";
import { LanguageSelector } from "./LanguageSelector";
import "./StandaloneBar.css";
import SessionInfo from './SessionInfo'
import { Link } from "react-router-dom";


export default function StandaloneBar() {

    return (
        <div className="standalone-bar">
            <Link to={`/`} className="standalone-link" >
                <img src="/3DS-Logo-white.png" alt="Application icon" width={36} />
                <Typography variant="h6">Halawai</Typography>
            </Link >
            <div className="standalone-actions">
                <LanguageSelector />
                <SessionInfo/>
            </div>
        </div>
    )
}